import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["values", "containerClassName"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import { DatePicker } from 'antd';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import _isEmpty from 'lodash/isEmpty';

// Constants
import { EMPTY_ARRAY, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
var RangePicker = DatePicker.RangePicker;

/*
  Using DateRange Picker in './DateRange.js' when time needs to be specified separately causes
  issue with consistency of Date and Time picker popup's open state when using with FilterSection
  and FilterDialog. That issue is solved in below implementation
 */

// DEPRECATED COMPONENT - WILL BE REMOVED BY 2.2.48 or earlier hotfix release
var DateTimeRange = /*#__PURE__*/function (_PureComponent) {
  _inherits(DateTimeRange, _PureComponent);
  var _super = _createSuper(DateTimeRange);
  function DateTimeRange(props) {
    var _this;
    _classCallCheck(this, DateTimeRange);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleOk", function () {
      var _this$state = _this.state,
        dateRangeValues = _this$state.dateRangeValues,
        isValueChanged = _this$state.isValueChanged;
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        showTime = _this$props.showTime;
      if (!isValueChanged) return;
      _this.setState({
        isValueChanged: false
      });
      if (_isEmpty(dateRangeValues)) {
        onChange(EMPTY_ARRAY);
        return;
      }
      if (showTime) {
        onChange(dateRangeValues);
        return;
      }
      var _dateRangeValues = _slicedToArray(dateRangeValues, 2),
        startMoment = _dateRangeValues[0],
        endMoment = _dateRangeValues[1];
      onChange([startMoment.startOf('day'), endMoment.endOf('day')]);
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
      if (!_isEmpty(value)) {
        _this.setState({
          dateRangeValues: value,
          isValueChanged: true
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOpen", function (status) {
      if (!status) {
        _this.handleOk();
      }
    });
    var values = props.values;
    _this.state = {
      dateRangeValues: values,
      isValueChanged: false
    };
    return _this;
  }
  _createClass(DateTimeRange, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        values = _this$props2.values,
        containerClassName = _this$props2.containerClassName,
        rest = _objectWithoutProperties(_this$props2, _excluded);
      var dateRangeValues = this.state.dateRangeValues;
      return /*#__PURE__*/React.createElement("div", {
        className: containerClassName
      }, /*#__PURE__*/React.createElement(RangePicker, _extends({
        separator: "-",
        allowClear: false
      }, rest, {
        value: dateRangeValues,
        onChange: this.handleChange,
        onOk: this.handleOk,
        onOpenChange: this.handleOpen
      })));
    }
  }]);
  return DateTimeRange;
}(PureComponent);
DateTimeRange.propTypes = {
  onChange: PropTypes.func,
  values: PropTypes.array,
  showTime: PropTypes.bool,
  className: PropTypes.string
};
DateTimeRange.defaultProps = {
  onChange: _noop,
  values: EMPTY_ARRAY,
  showTime: false,
  className: EMPTY_STRING
};
export default DateTimeRange;